import { cartLineToGa4Item, pushGa4EcommerceEvent } from "./ga4Ecommerce";

const pending = new WeakMap<object, Set<string>>();

/** Track a confirmed addition; a toggle-off, failed save or repeated tap is not an addition. */
export async function toggleWishlistWithTracking(store: any, product: any) {
  if (!product?.id) return;
  const id = String(product.id);
  const locks = pending.get(store) || new Set<string>();
  pending.set(store, locks);
  if (locks.has(id)) return;
  locks.add(id);
  const contains = () =>
    (store.getters["store/wishlist/get"] || []).some(
      (item: any) => String(item.id) === id
    );
  const existed = contains();
  const item = cartLineToGa4Item({ product, quantity: 1 });
  try {
    const result = await store.dispatch("store/wishlist/add", { product });
    const succeeded = (Array.isArray(result) ? result : [result]).every(
      (entry) => entry?.ok === true
    );
    if (!succeeded || existed || !contains() || typeof window === "undefined")
      return result;
    pushGa4EcommerceEvent("add_to_wishlist", {
      currency: "USD",
      value: item.price,
      items: [item],
    });
    if (window.vfConsent?.has("marketing") === true) {
      window.fbq?.("track", "AddToWishlist", {
        content_ids: [id],
        content_name: [item.item_name],
        content_type: "product",
        value: item.price,
        currency: "USD",
      });
    }
    return result;
  } finally {
    locks.delete(id);
  }
}
